import React from "react";
import MainTable from "../../../components/requestsource-table/request-table"

////////////////////////////////////////////////TABLE COLUMN HEADERS SET UP////////////////////////////////////////////////////////////////////////////////////////
const TableData = ({ resetMenu }: any) => {

  return (<MainTable pageTitle="KYC Registry History" pageName="history"  resetMenu={resetMenu}/>)
}
export default TableData;
